import { FieldBlock, SelectField } from '@politechdev/blocks-design-system'
import {
  CanvasserSelectField,
  TurfSelectField,
  UserSelectField,
} from 'components'
import { useTranslation } from 'react-i18next'
import { TABS } from 'performanceReviews/constants'
import { PerformanceReviewFilters, TabType } from 'performanceReviews/types'
import humanizeString from 'humanize-string'

const statusOptions: Array<{
  label: string
  value: string | undefined
}> = ['open', 'ready_for_review'].map(status => ({
  label: humanizeString(status),
  value: status,
}))

const Filters = ({
  filters,
  updateFilters,
  activeTab,
}: {
  filters: PerformanceReviewFilters
  updateFilters: (updates: Partial<PerformanceReviewFilters>) => void
  activeTab: TabType
}) => {
  const { t } = useTranslation()

  return (
    <FieldBlock>
      <UserSelectField
        label={t('Assigned to')}
        user={filters.user}
        onSelect={user => updateFilters({ user })}
        clearable
      />
      <CanvasserSelectField
        label={t('Canvasser')}
        selectedCanvasser={filters.canvasser}
        onSelect={canvasser => updateFilters({ canvasser })}
        clearable
      />
      <TurfSelectField
        label={t('Turf')}
        value={filters.turf}
        onSelect={turf => updateFilters({ turf })}
        onClear={() => updateFilters({ turf: undefined })}
        clearable
      />
      {activeTab === TABS.ACTIVE && (
        <SelectField
          label={t('status')}
          value={filters.status}
          onSelect={status => updateFilters({ status })}
          options={statusOptions}
          clearable
        />
      )}
    </FieldBlock>
  )
}

export default Filters
